module.exports = __webpack_public_path__ + "img/1.8736db95.png";